import { CAMERA_STATUS, SEARCH, SORT } from 'constants/FilterConstants';
import type { CameraStatus } from 'modules/cameras/types';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { getPersistedFilters } from 'services/StateLoader';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

export type CamerasFilters = {
  [SEARCH]: string | null;
  [CAMERA_STATUS]: Array<CameraStatus>;
  [SORT]: string;
};

const persistedFilters = getPersistedFilters()?.filters?.cameras ?? {};

const emptyState: CamerasFilters = {
  [SEARCH]: null,
  [CAMERA_STATUS]: [],
  [SORT]: 'name,ASC',
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

export default createReducer<CamerasFilters>(filterAdapter.getInitialState(), {
  [types.SET_CAMERAS_DASHBOARD_FILTER]: filterAdapter.setFilter,
  [types.SET_CAMERAS_DASHBOARD_FILTERS]: filterAdapter.setFilters,
  [types.CLEAR_CAMERAS_DASHBOARD_FILTER]: filterAdapter.resetFilters,
  [types.REMOVE_CAMERAS_DASHBOARD_FILTER]: filterAdapter.removeFilter,
});
